import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ChevronDown, ChevronRight } from 'lucide-react';

import logo from '../assets/logo.png';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className='px-6 py-8 border-t sm:py-16 border-neutral-200 sm:px-8'>
      <div className='max-w-6xl mx-auto'>
        <div className='grid gap-10 mb-12 md:grid-cols-4'>
          {/* BRAND */}

          <div>
            <NavLink
              to='/'
              className='flex flex-col gap-4 mb-4 text-base font-semibold'
            >
              <img className='w-20 aspect-square' src={logo} alt='logo' />
              Tomado Design
            </NavLink>

            <p className='max-w-xs text-sm text-neutral-600'>
              A creative design studio crafting modern brands, logos and digital
              experiences.
            </p>
          </div>

          {/* PORTFOLIO */}

          <FooterSection title={t('nav.portfolio')}>
            <FooterLink to='/portfolio/branding'>Branding</FooterLink>

            <FooterLink to='/portfolio/web'>Web Design</FooterLink>

            <FooterLink to='/portfolio/development'>Development</FooterLink>

            <FooterLink to='/portfolio/graphic'>Graphic Design</FooterLink>
          </FooterSection>

          {/* STUDIO — direct link */}

          <div>
            <NavLink
              to='/studio'
              className='flex items-center justify-between w-full font-medium transition hover:text-black'
            >
              Studio
              <ChevronRight size={16} className='text-neutral-400' />
            </NavLink>
          </div>

          {/* CONTACT */}

          <FooterSection title='Contact'>
            <p className='text-sm text-neutral-600'>tomado_d@tomadodesign.kr</p>

            <p className='mb-4 text-sm text-neutral-600'>
              zero@tomadodesign.kr
            </p>

            <p className='mt-4 mb-2 font-medium'>SNS Links</p>

            <a
              href='https://instagram.com/tomado_d'
              target='_blank'
              rel='noopener noreferrer'
              className='text-sm transition text-neutral-600 hover:text-black'
            >
              Instagram
            </a>

            <a
              href='https://kmong.com'
              target='_blank'
              rel='noopener noreferrer'
              className='text-sm transition text-neutral-600 hover:text-black'
            >
              Kmong
            </a>
          </FooterSection>
        </div>

        {/* bottom */}

        <div className='flex flex-col items-center justify-between gap-2 pt-6 text-sm border-t border-neutral-200 text-neutral-500 sm:flex-row'>
          <p>© 2026 Tomado Design</p>

          <p className='hidden sm:block'>Design studio for modern brands</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

/* =====================================================
   SECTION (Accordion)
===================================================== */

const FooterSection = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* HEADER */}

      <button
        onClick={() => setOpen(!open)}
        className='flex items-center justify-between w-full font-medium md:pointer-events-none'
      >
        {title}

        <ChevronDown
          size={16}
          className={`
            transition
            md:hidden
            ${open ? 'rotate-180' : ''}
          `}
        />
      </button>

      {/* CONTENT */}

      <div
        className={`
          overflow-hidden
          transition-all
          duration-300

          ${open ? 'max-h-[400px] mt-4' : 'max-h-0 md:max-h-none md:mt-4'}
        `}
      >
        <div className='flex flex-col gap-2 text-sm text-neutral-600'>
          {children}
        </div>
      </div>
    </div>
  );
};

/* =====================================================
   LINK
===================================================== */

const FooterLink = ({ to, children }) => (
  <NavLink to={to} className='transition hover:text-black'>
    {children}
  </NavLink>
);
